import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useCheckoutLoaderRedesignExperiment = () => {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.CHECKOUT_LOADER_REDESIGN)
  return (
    init && experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CHECKOUT_LOADER_REDESIGN].buckets?.show
  )
}
